import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Block, Typography } from '../typography';

export const ModalContextMessage = ({ message, subMessage }: { message: ReactNode; subMessage?: ReactNode }) => {
  return (
    <BlockWrapper>
      <Typography size="lg" weight="bold">
        {message}
      </Typography>
      {subMessage && (
        <Typography size="md" weight="regular">
          {subMessage}
        </Typography>
      )}
    </BlockWrapper>
  );
};

const BlockWrapper = styled(Block)`
  display: flex;
  flex-direction: column;
  > * + * {
    margin-top: 0.6rem;
  }
`;
